import {useEffect} from "react";

export const AppLoaded = () => {
    useEffect(()=>{
        window?.ReactNativeWebView?.postMessage('AppLoaded');
    },[])
    return null
}